// AI credit balance data model for the SaaS billing prototype.
// See plans/saas-billing/01-stripe-billing-foundation.md for canonical types.

export interface AICreditBalance {
  tenantId: string;
  billingCycleStart: string;
  billingCycleEnd: string;
  // Subscription-allocated credits (reset each cycle)
  allocatedCredits: number;
  usedCredits: number;
  reservedCredits: number;             // In-flight requests
  // Non-expiring top-up credits (carry over cycles)
  topUpBalance: number;
  // Aggregates
  remainingCredits: number;            // allocated - used - reserved + topUpBalance
  basicTurnsAllocated: number;
  basicTurnsUsed: number;
}
